/* eslint-disable no-nested-ternary */
import { useEffect, useState } from 'react';
import { icons } from '~/assets';
import AutoCompleteSelect from '~/components/AutoCompleteSelect';
import Button from '~/components/button';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import Endpoints from '~/services/endpoints';
import { httpRequest } from '~/services/httpRequest';
import { cnpjExtendedMask, cnpjMask, cpfMask, dateMask, IDefaultReturn } from '~/utils/masks';
import { getCompaniesHttp } from '../Establishment/actions';
import ParametersData from './data';
import * as St from './styles';

interface Address {
  bairro: string;
  cep: string;
  cidade: string;
  complemento: string;
  logradouro: string;
  numero: string;
  pais: string;
  uf: string;
}

interface IEstablishment {
  cpf: string;
  cnpj: string;
  email: string;
  endereco: Address;
  id: string;
  telefone: string;
}

interface IEstablishmentResponse {
  currentPage: number;
  data: IEstablishment[];
  pageSize: number;
  totalItens: number;
  totalPages;
}

interface IForm {
  name: string;
  cpfCnpj: IDefaultReturn;
  estabilishment: string;
}

const splitsModalitiesDefault = [
  {
    modality: 'A_VISTA',
    percentualSplit: 0,
  },
  {
    modality: 'PARCELADO_2X',
    percentualSplit: 0,
  },
  {
    modality: 'PARCELADO_3X',
    percentualSplit: 0,
  },
  {
    modality: 'PARCELADO_4X',
    percentualSplit: 0,
  },
  {
    modality: 'PARCELADO_5X',
    percentualSplit: 0,
  },
  {
    modality: 'PARCELADO_6X',
    percentualSplit: 0,
  },
  {
    modality: 'PARCELADO_7X',
    percentualSplit: 0,
  },
  {
    modality: 'PARCELADO_8X',
    percentualSplit: 0,
  },
  {
    modality: 'PARCELADO_9X',
    percentualSplit: 0,
  },
  {
    modality: 'PARCELADO_10X',
    percentualSplit: 0,
  },
  {
    modality: 'PARCELADO_11X',
    percentualSplit: 0,
  },
  {
    modality: 'PARCELADO_12X',
    percentualSplit: 0,
  },
];

const TeuPagConsult = () => {
  const [form, setForm] = useState<IForm>({} as IForm);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [allEstablishment, setAllEstabilshment] = useState([]);

  const getSearchEstablishments = async (params?) => {
    const response = await getCompaniesHttp({
      limite: 1000,
      page: currentPage,
      ...params,
    });
    if (response.status === 200) {
      const { data, page, totalPages } = response.data;
      setAllEstabilshment(data);
      setCurrentPage(page);
      setTotalPages(totalPages);
      return data;
    }
  };
  useEffect(() => {
    getSearchEstablishments();
  }, []);

  const [parameters, setParameters] = useState(null);
  const getDetailsEstablishments = async () => {
    setParameters(null);
    try {
      const response = await httpRequest({
        url: Endpoints.companies.getCompanyDetails.replace(
          'PARAM_CPF',
          form.estabilishment,
        ),
      });
      // const response = await axios.get(
      //   `http://localhost:8128/v1/companies/find-company-by-code/${form.estabilishment}`,
      //   {
      //     headers: {
      //       Authorization: ``
      //     }
      //   }
      // );

      const { data } = response;

      const bank = data?.homeAccount;
      const parametersObject = {
        id: data?.id,
        partnership: data?.partnership,
        generalParametersData: data?.generalParameters
          ? {
              mcc: data?.generalParameters?.mcc,
              captureMethod: data?.generalParameters?.captureMethod,
              posQuantity: data?.generalParameters?.posQuantity,
              monthlyCardTotalRevenue:
                data?.generalParameters?.monthlyCardTotalRevenue,
              repassCondition: data?.generalParameters?.repassCondition,
            }
          : {},
        generalParametersAgreement: data?.generalParametersAgreement
          ? {
              invoiceDueDay: dateMask(
                data?.generalParametersAgreement?.invoiceDueDay || '',
              ),
              invoiceEmails: Array.isArray(
                data?.generalParametersAgreement?.invoiceEmails,
              )
                ? data?.generalParametersAgreement?.invoiceEmails.map((i) => ({
                    id: i,
                    value: i,
                  }))
                : [],
            }
          : {},
        splitsModalities:
          data?.splitsModalities?.map((split) => ({
            modality: split?.splitPayment,
            percentualSplit: split?.percentual,
          })) ?? splitsModalitiesDefault,
        bankData: {
          accountHolder: {
            holderName: bank?.accountHolder?.holderName,
            cpfCnpj:
              bank?.accountHolder?.cpfCnpj?.length > 11
                ? cnpjMask(bank?.accountHolder?.cpfCnpj)
                : cpfMask(bank?.accountHolder?.cpfCnpj),
          },
          bankName: bank?.bankFullName,
          agency: bank?.branch,
          account: bank?.account,
          digit: bank?.digit,
          bank: bank?.bankIspb,
          code: bank?.bankCode,
          type: bank?.accountType?.replace('_', ''),
        },
      };

      if (response.status === 200) {
        setParameters(parametersObject);
      }
    } catch (error) {
      console.log(error);
      setOpenDialog(true);
      setMessage(error?.response?.data?.mensagem ?? 'Houve um erro');
    }
  };

  return (
    <>
      <Dialog
        open={openDialog}
        icon={icons.exclamation}
        positiveAction={() => {
          setOpenDialog(false);
        }}
        message={message}
        positiveLabel="Entendi"
      />
      <Container>
        <St.BoxCard>
          <ContainerFlex row>
            <ContainerFlex flex={1} marginRight={16}>
              <AutoCompleteSelect
                options={allEstablishment.map((e) => ({
                  value: `${e.name} - ${
                    e.document.length > 11
                      ? cnpjExtendedMask(e.document).masked
                      : cpfMask(e.document).masked
                  }`,
                  id: e.document,
                  key: e.id,
                }))}
                label="Estabelecimento"
                getOptionKey={(op) => op?.key}
                filterFunction={(options, filterText) =>
                  options.filter((op) =>
                    op.value
                      ?.toLowerCase()
                      ?.trim()
                      .includes(filterText?.toLowerCase()?.trim()),
                  )
                }
                value={form.name}
                onChange={(e) => {
                  setForm({
                    ...form,
                    estabilishment: e.id,
                  });
                }}
              />
            </ContainerFlex>

            <ContainerFlex end row gap="30">
              <Button
                fitContent
                onClick={() => getDetailsEstablishments()}
                disabled={!form.estabilishment}
              >
                Consultar
              </Button>
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>

        {parameters ? <ParametersData parameters={parameters} /> : null}
      </Container>
    </>
  );
};

export default TeuPagConsult;
